import React from 'react';
import contactLeft from '../img/png/contact_background_left.png';
import contactRight from '../img/png/contact_background_right.png';
import contactBanner from '../img/png/contact_banner.png';
import ContactForm from './subcomponents/ContactForm';

function Contact() {
  return (
    <>
      <section
        id='contact'
        className='contactform d-flex align-items-center justify-content-center '
      >
        <div
          className='contactform_container
         d-flex align-items-center justify-content-between'
        >
          <div className='contactform_container_left flex-1'>
            <div className='d-flex-col gap-2'>
              <div className='text'>
                <h2 className='text-title'>Let us show you how it works</h2>
                <p className='text-gray'>
                  Get started right away with ONE Market.
                </p>
                <div className='line'></div>
              </div>
            </div>
            <ContactForm />
          </div>
          {/* right */}
          <div className='contactform_container_right flex-1'>
            <img src={contactBanner} alt='background' />
          </div>
        </div>
        {/* background */}
        <div className='contactform_background d-flex justify-content-around'>
          <div className='contactform_background_left d-flex align-items-center'>
            <img src={contactLeft} alt='background' />
          </div>
          <div className='contactform_background_right d-flex-col justify-content-center'>
            <img src={contactRight} alt='background' />
          </div>
        </div>
        {/* {window.hbspt.forms.create({
          region: 'na1',
          portalId: '19533150',
          formId: '657aa674-91e7-44ca-86d1-d03fad6710e9',
        })} */}
      </section>
    </>
  );
}

export default Contact;
